import { Suspense, type PropsWithChildren } from 'react'

import { ListaQuadrasEspelhoDeVendasHorizontalSkeleton } from '@/features/espelho-de-vendas/brasil/pages/espelho-de-vendas-horizontal/espelho-de-vendas-horizonta.skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'

export const EspelhoDeVendasHorizontalPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ListaQuadrasEspelhoDeVendasHorizontalSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
